import React, { useCallback, useEffect, useRef, useState } from "react";
import { apiCall } from "./ApiCall";
import "../css/others/RoleSelectionModal.css";
import ToastPopup from "../popups/ToastPopup";
import { RoleSelectionModalProps, RoleSelection, createToastMessage, ToastMessage } from "../interFaces/interfaces";
import EncryptionUtils from "./encryptionUtils";
import { useNavigate } from "react-router-dom";
const RoleSelectionModal: React.FC<RoleSelectionModalProps> = ({ onRoleSelected, setIsAuthenticated, }) => {
  const [roles, setRoles] = useState<RoleSelection[]>([]);
  const [selectedRole, setSelectedRole] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(true);
  const [shouldRender, setShouldRender] = useState<boolean>(false);
  const [message, setMessage] = useState<ToastMessage | null>(null);
  const userEmail = localStorage.getItem("email");
  const clientId = localStorage.getItem("clientId");
  const navigate = useNavigate();
  const hasFetched = useRef(false);
  const handleRoleSelect = useCallback(
    (roleId: string, roleName: string) => {
      try {
        setLoading(true);
        setSelectedRole(roleId);
        EncryptionUtils.set("roleId", roleId);
        EncryptionUtils.set("roleName", roleName);
        localStorage.setItem("authEvent", JSON.stringify({ type: "LOGIN" }));
        onRoleSelected();
        navigate("/dashboard");
      } catch (err) {
        setMessage(createToastMessage("Failed to set role. Please try again.", "error", 3000));
      } finally {
        setLoading(false);
      }
    },
    [onRoleSelected, navigate]
  );
  useEffect(() => {
    if (hasFetched.current) return;
    hasFetched.current = true;
    const fetchRoles = async () => {
      try {
        if (!userEmail) {
          setMessage(createToastMessage("Email not found. Please login again.", "error", 3000));
          setShouldRender(true);
          return;
        }
        const rolesData: RoleSelection[] = await apiCall("get", `/api/users/userinfo?email=${userEmail}&clientId=${clientId}`);
        if (rolesData.length === 0) {
          setMessage(createToastMessage("No roles found for your account.", "error", 3000));
          setShouldRender(true);
        } else if (rolesData.length === 1) {
          const { roleId, roleName } = rolesData[0];
          handleRoleSelect(roleId, roleName);
        } else {
          setRoles(rolesData);
          setShouldRender(true);
        }
      } catch (err: any) {
        if (err.response?.status === 403) {
          setMessage(createToastMessage("Access denied. Please contact your administrator.", "error", 3000));
        } else {
          setMessage(createToastMessage("Failed to fetch roles. Please try again.", "error", 3000));
        }
        setTimeout(() => setIsAuthenticated(false), 3000);
      } finally {
        setLoading(false);
      }
    };
    fetchRoles();
  }, [userEmail, clientId, handleRoleSelect, setIsAuthenticated]);
  if (loading || !shouldRender) return null;
  return (
    <div className="role-modal-overlay">
      <div className="role-modal">
        <h2 className="radio-text">Welcome</h2>
        <p className="radio-text">Please select your role</p>
        <div className="role-list">
          {roles.map((role) => (
            <label key={role.roleId} className={`role-radio ${selectedRole === role.roleId ? "selected" : ""}`}>
              <input type="radio" name="role" value={role.roleId} checked={selectedRole === role.roleId} onChange={() => handleRoleSelect(role.roleId, role.roleName)} disabled={loading} />
              <div className="custom-radio"></div>
              <span>{role.roleName}</span>
            </label>
          ))}
        </div>
        {loading && <div className="spinner-roleselect"></div>}
        {message && (<ToastPopup message={message.text} type={message.type} duration={message.duration} onClose={() => setMessage(null)} />)}
      </div>
    </div>
  );
};
export default RoleSelectionModal;